import { useEffect, useState } from "react"
import { ProductYield } from "../../../state/types"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { Product } from "../../../../products"
import { ProductYieldForm } from "./productYieldForm"

type Props = {
    defaultData?: Partial<ProductYield>
    baseCustomerTypeId?: string
    filterProducts?: (product: Product) => boolean
    onSubmit: (data: Partial<ProductYield>) => void
}

export const ProductYieldFormModal = (props: Props) => {
    const { defaultData, baseCustomerTypeId, filterProducts, onSubmit } = props

    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])

    return (
        <Modal
            modalId={ModalId.PRODUCT_YIELD_FORM}
            title="Agregar Producto"
            actions={[]}
            widthSize="m"
        >
            <ProductYieldForm
                key={key}
                defaultData={defaultData}
                baseCustomerTypeId={baseCustomerTypeId}
                filterProducts={filterProducts}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
